import { clinicalPlans } from "./plansMapping";

/** Plan lengths in weeks (1 month = 4 weeks). */
export type MembershipPlanWeeks = 4 | 12 | 24 | 48;

/** Plans sold in several lengths, named as in variant keys. */
export type MembershipPlanProduct =
  | "membership"
  | "brandedMembership"
  | "brandedAsyncMembership";

type MembershipPlanLength = { planKey: string; weeks: MembershipPlanWeeks };

let membershipPlanLengths:
  | Record<MembershipPlanProduct, ReadonlyArray<MembershipPlanLength>>
  | undefined;

export function getMembershipPlanLengths() {
  if (!membershipPlanLengths) {
    membershipPlanLengths = {
      membership: [
        { planKey: clinicalPlans.membership12Months, weeks: 48 },
        { planKey: clinicalPlans.membership6Months, weeks: 24 },
        { planKey: clinicalPlans.membership3Months, weeks: 12 },
        { planKey: clinicalPlans.membership, weeks: 4 },
      ],
      brandedMembership: [
        { planKey: clinicalPlans.brandedMembership12Months, weeks: 48 },
        { planKey: clinicalPlans.brandedMembership6Months, weeks: 24 },
        { planKey: clinicalPlans.brandedMembership3Months, weeks: 12 },
        { planKey: clinicalPlans.brandedMembership, weeks: 4 },
      ],
      brandedAsyncMembership: [
        { planKey: clinicalPlans.brandedAsyncMembership48Weeks, weeks: 48 },
        { planKey: clinicalPlans.brandedAsyncMembership24Weeks, weeks: 24 },
        { planKey: clinicalPlans.brandedAsyncMembership12Weeks, weeks: 12 },
        { planKey: clinicalPlans.brandedAsyncMembership, weeks: 4 },
      ],
    };
  }
  return membershipPlanLengths;
}

/** Plan keys of one membership plan, longest first. */
export const getMembershipPlanKeys = (product: MembershipPlanProduct) =>
  getMembershipPlanLengths()[product].map(({ planKey }) => planKey);

/** Branded sync membership of the given length in weeks. */
export function getBrandedMembershipPlanKeyForWeeks(
  weeks: number | undefined
): string {
  const brandedPlan = getMembershipPlanLengths().brandedMembership.find(
    (plan) => plan.weeks === weeks
  );

  if (!brandedPlan) {
    throw new Error(
      `No branded membership plan matches a membership of ${weeks} weeks`
    );
  }

  return brandedPlan.planKey;
}
